"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

/*
 The Omniture implementation on the 2017 PIP Page and CP:
 On the load of the page, js_sitecatalyst loads s_code.js and s_code_wrapper.js onto the page, with pre-populated
 environment variables that are injected by analytics services in app code. This process creates a window.scw object
 which then transfers its data to the window.s omniture tracking object which is the basis for interacting with
 omniture. By mutating the fields of this s object, and then calling the s object with a click - s.tl() event or load -
 s.t() event, data is sent to omniture. These methods here abstract away the mutation of the required variables/data and
 calls for specific tracking events determined by the omniture team at shutterfly and are called within the
 react components which make up the thumbnail page.
 v-gtsolov - 17/08/17, thanks to rhang

 Omniture DTL uses JSON-based reporting rather than event numbers and variable numbers. For standalone Javascript apps,
 there is a new servlet that delivers all of the information needed for reporting along with most of the supporting
 code. This page documents both JSP-based and standalone reporting.
 v-gnikolov - 19/03/2018, V2 added Omniture support for DTL
 */
var ERROR_MESSAGE = 'Omniture beacon elements are missing from page';
var instance = null,
    omniture = null;

var Omniture =
/*#__PURE__*/
function () {
  function Omniture() {
    (0, _classCallCheck2.default)(this, Omniture);

    //create singleton object
    if (!instance) {
      instance = this;
    }

    return instance;
  }
  /*
   Get page name based on the global window.SFLY_DTL object
   */


  (0, _createClass2.default)(Omniture, [{
    key: "getPageName",
    value: function getPageName() {
      return window.SFLY_DTL ? window.SFLY_DTL.global.pageName : '';
    }
    /*
     Get brand name based on the body class name
     */

  }, {
    key: "getBrandName",
    value: function getBrandName() {
      if (window.SFLY_DTL) {
        return document.body.classList.contains('brand-SFLY') ? 'shutterfly' : 'tinyprints';
      }
    }
    /*
     Get the user agent to see if is mobile or not
     */

  }, {
    key: "getUserAgent",
    value: function getUserAgent() {
      return navigator ? navigator.userAgent : '';
    }
    /*
     Get the user state helper function, only when the user is logged in
     */

  }, {
    key: "getUserState",
    value: function getUserState() {
      return window.SFLY_DTL ? window.SFLY_DTL.global.getUserState : '';
    }
    /*
     Check for 's' and 'scw' objects
     */

  }, {
    key: "isOmnitureLoaded",
    value: function isOmnitureLoaded() {
      var s = window.s,
          scw = window.scw;

      if (!s || !scw) {
        return false;
      }

      return true;
    }
    /*
     Clear window.SFLY_DTL.page.pageDetails object
     */

  }, {
    key: "clearDtlPageDetails",
    value: function clearDtlPageDetails() {
      if (window.SFLY_DTL && window.SFLY_DTL.page) {
        if (window.SFLY_DTL.page.pageDetails) {
          delete window.SFLY_DTL.page.pageDetails;
        }
      }
    }
    /*
     Clear window.SFLY_DTL.page.productDetails object
     */

  }, {
    key: "clearDtlProductDetails",
    value: function clearDtlProductDetails() {
      if (window.SFLY_DTL && window.SFLY_DTL.page) {
        if (window.SFLY_DTL.page.productDetails) {
          delete window.SFLY_DTL.page.productDetails;
        }
      }
    }
    /*
    Check for window.DTLSiteFeatureEnabled which is set in setupOmnitureTracking() ajax request
    */

  }, {
    key: "isDTLEnabled",
    value: function isDTLEnabled() {
      return window.DTLSiteFeatureEnabled;
    }
    /*
     Omniture DTL method for event tracking
     */

  }, {
    key: "putOmniture",
    value: function putOmniture(data) {
      var host = window.location.origin; //delete DTL pageDetails & ProductDetails from SFLY_DTL.page object
      // this.clearDtlPageDetails();
      // this.clearDtlProductDetails();
      //remove the event information because merged data stays in SFLY_DTL

      window.$omnitureDTL.removeOmnitureJSPData(host, 'event'); //wait till some JSP posts omniture data into the DTL buffer

      window.$omnitureDTL.processOmnitureJSPData(null); //wait until the DTL buffer is available, and then fill it with this new JSP data.

      window.$omnitureDTL.putOmnitureJSPData(host, data);
    }
    /*
     Set up old omniture or omniture DTL depending on site feature.
     */

  }, {
    key: "setupOmnitureTracking",
    value: function setupOmnitureTracking(appServerUrl, callback) {
      var isDTLEnabled = this.isDTLEnabled; //call e.g. https://www.beta.shutterfly.com/rest/omnitureDTL/adobeDTM.siteCatalyst.DTL
      //to read appServer site feature + supporting code.

      _axios.default.get("".concat(appServerUrl, "/rest/omnitureDTL/adobeDTM.siteCatalyst.DTL")).then(function (response) {
        //executing the text response as a script
        if (response.data) {
          eval(response.data); // eslint-disable-line
        }

        if (isDTLEnabled()) {
          window.$omnitureDTL.setupOmnitureDTLTracking(appServerUrl, function (options) {
            callback(true);
          }, null);
        } else {
          callback(false);
        }
      }).catch(function (error) {
        callback(false);
      });
    }
    /*
     Set the following values to be available on load of the CGD pages. Values in brackets should be populated
     dynamically for each page.
     Only populate the product values for the product sku viewed on load. siteExperience mobile,  desktop or tablet
     */

  }, {
    key: "trackDTLPageLoad",
    value: function trackDTLPageLoad(pageInfo, pageDetails, productDetails, projectDetails, delayedPageLoad) {
      var host = window.location.origin; //get session info and drop it into buffer, then get page-specific info and drop that too

      window.$omnitureDTL.loadOmnitureSession(host, function (session) {
        //tell bridge not to clobber existing populated values. Just a heads up in case that comes in handy someday
        session.noClobber = true; //remove the event information because merged data stays in SFLY_DTL

        window.$omnitureDTL.removeOmnitureJSPData(host, 'event'); //wait till some JSP posts omniture data into the DTL buffer

        window.$omnitureDTL.processOmnitureJSPData(null);
        var dtlData = {
          page: {}
        };

        if (delayedPageLoad) {
          dtlData.delayedPageLoad = delayedPageLoad;
        }

        if (pageInfo) {
          dtlData.page.pageInfo = pageInfo;
        }

        if (session) {
          dtlData.session = session.session;
        }

        if (session.page.pageInfo && pageInfo) {
          dtlData.page.pageInfo.siteExperience = session.page.pageInfo.siteExperience;
        }

        if (pageDetails) {
          dtlData.page.pageDetails = pageDetails;
        }

        if (productDetails) {
          dtlData.page.productDetails = productDetails;
        }

        if (projectDetails) {
          dtlData.page.projectDetails = projectDetails;
        }

        window.$omnitureDTL.putOmnitureJSPData(host, dtlData);
      });
    }
    /*
     This is the main method of the module. From here you can send data to the omniture tracking system.
     What we need for this method is array of json objects. See the documentation to see the proper json schema.
     The second argument for the method is the linkName, which is going to be used in request adobe method
     s.t or s.tl. The last argument is for the type of the tracking 'tl' - if you want to track page
     link click or 't' - if you want to track page load events
     */

  }, {
    key: "trackPage",
    value: function trackPage(omnitureParams, linkName, typeTracking) {
      //if there is no 's' or 'scw' objects or proper array of json added, stop the logic underneath
      if (!omnitureParams || !this.isOmnitureLoaded()) {
        return;
      }

      var s = window.s,
          objectKeyInVars = [],
          objectKey = [],
          prop13Element = document.createElement('div');
      var prop13ElementContent = null,
          linkNameValue = null; //get all the keys from the object and all the keys that is needed to s.linkTrackVars

      omnitureParams.forEach(function (param) {
        if ((0, _keys.default)(param)[0] !== 'linkTrackVars' && (0, _keys.default)(param)[0] !== 'linkTrackEvents') {
          objectKeyInVars.push((0, _keys.default)(param)[0]);
        }

        objectKey.push((0, _keys.default)(param)[0]);
      }); //clear all the props and vars of window.s object that are passed to omnitureParams argument

      this.clearVars(objectKey); //assign the params to the global window.s object

      omnitureParams.forEach(function (param) {
        var getKey = (0, _keys.default)(param)[0]; //if it's a prop13 create shadow DOM elements, so we can pass the needed text to s.tl omniture funciton

        if (getKey === 'prop13') {
          prop13ElementContent = document.createTextNode(param[getKey]);
          prop13Element.appendChild(prop13ElementContent);
        }

        s[getKey] = param[getKey];
      }); //there is a relation between s.prop12, s.prop13, s.prop14

      if (objectKey.indexOf('prop13') !== -1) {
        s.prop12 = this.getPageName();
        s.prop14 = "".concat(s.prop12, "|").concat(s.prop13);
        objectKeyInVars.push('prop12', 'prop14');
      } //there is a relation between s.linkTrackEvents and s.events


      if (objectKey.indexOf('linkTrackEvents') !== -1) {
        s.events = s.linkTrackEvents;
        objectKeyInVars.push('events');
      }

      s.linkTrackVars = objectKeyInVars.join(); //populate the linkTrackVars variable

      linkNameValue = linkName ? linkName : s.prop14; //check if we are going to track something on link click or page load

      if (typeTracking === 'tl' || !typeTracking) {
        s.tl(prop13Element, 'o', linkNameValue);
      } else {
        s.t(true, 'o', linkNameValue);
      }
    }
    /*
     This method will clear all the proprs and vars added to the array of objects.
     */

  }, {
    key: "clearVars",
    value: function clearVars(omnitureParams) {
      var s = window.s;

      if (omnitureParams) {
        omnitureParams.push('linkTrackVars', 'prop1', 'prop12', 'prop14', 'eVar6', 'events');
        omnitureParams.forEach(function (param) {
          if ((0, _typeof2.default)(s[param]) !== undefined) {
            delete s[param];
          }
        });
      }
    }
  }]);
  return Omniture;
}();

var _default = omniture = new Omniture();

exports.default = _default;

//# sourceMappingURL=omniture.js.map